<template>
	<div class="bg-light min-vh-100 p-4 p-md-5">
		<div class="card shadow-sm border w-100">
			<div class="card-body p-4 p-md-5">
				<!-- Evaluation Details Section -->
				<div class="border-bottom pb-5 mb-5">
					<div class="container mt-5">
						<h2 class="h4 fw-bold mb-4 fs-3">
							Recommendation Details
						</h2>
						<div class="quotation-card bg-light">
							<div class="row g-4">
								<div class="col-md-6">
									<label
										class="form-label fw-semibold text-dark fs-5"
										>Created Date</label
									>
									<p class="fs-4">
										{{
											formatDate(
												selectedClientRecommendation.createdAt,
											)
										}}
									</p>
								</div>
								<div class="col-md-6">
									<label
										class="form-label fw-semibold text-dark fs-5"
										>Intermediary</label
									>
								</div>
							</div>
							<div class="mt-4 col-md-6">
								<label
									class="form-label fw-semibold text-dark fs-5"
									>Status</label
								>
								<p>{{ selectedClientRecommendation.status }}</p>
							</div>
						</div>
					</div>
				</div>

				<!-- Name and Related Details Section -->
				<div class="container mt-5">
					<div class="mb-5 profile-card bg-light">
						<div class="row g-4">
							<div
								class="col-md-2 d-flex justify-content-center align-items-center"
							>
								<img
									src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=3773&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
									alt="Profile"
									class="profile-img"
									style="max-width: 100%"
								/>
							</div>
							<div class="col-md-10">
								<div class="row">
									<div class="col-md-6">
										<div class="mb-3">
											<label
												class="form-label fw-semibold text-dark fs-5"
												>Product</label
											>
											<p class="fs-6 mb-0">
												{{
													selectedClientRecommendation
														.product_details
														.product_name
												}}
											</p>
										</div>
										<div class="mb-3">
											<label
												class="form-label fw-semibold text-dark fs-5"
												>Premium</label
											>
											<p class="fs-6 mb-0">
												{{
													selectedClientRecommendation.premium_amount
												}}
												{{
													selectedClientRecommendation.preferred_currency
												}}
											</p>
										</div>
									</div>
									<div class="col-md-6">
										<div class="mb-3">
											<label
												class="form-label fw-semibold text-dark fs-5"
												>Remarks</label
											>
											<p class="fs-6 mb-0">
												{{
													selectedClientRecommendation.recommendation_remarks
												}}
											</p>
										</div>
										<div class="mb-3">
											<label
												class="form-label fw-semibold text-dark fs-5"
												>Level</label
											>
											<div class="star-rating fs-5 mt-2">
												<i
													v-for="n in selectedClientRecommendation.recommendation_level"
													:key="'filled-' + n"
													class="fa-solid fa-star checked"
												></i>
												<i
													v-for="n in 5 -
													selectedClientRecommendation.recommendation_level"
													:key="'empty-' + n"
													class="fa-solid fa-star"
												></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Benefits Section -->
				<div class="mb-5">
					<h3 class="h5 fw-bold mb-4">Benefits</h3>
					<div class="row g-4">
						<div class="col-md-12">
							<!-- Loop through product_benefit_details -->
							<div
								v-for="benefit in selectedClientRecommendation.product_benefit_details"
								:key="benefit._id"
								class="d-flex align-items-center mb-3"
							>
								<div class="form-check me-3">
									<input
										class="form-check-input"
										type="radio"
										name="benefits"
										:id="
											'benefit' +
											benefit.product_benefit_id
										"
										:value="benefit.product_benefit_id"
										v-model="selectedBenefit"
									/>
									<label
										class="form-check-label fw-semibold text-dark"
										:for="
											'benefit' +
											benefit.product_benefit_id
										"
									>
										Benefit {{ benefit.id }}
										<!-- Replace with benefit.name if available -->
									</label>
								</div>
								<input
									v-if="
										selectedBenefit ===
										benefit.product_benefit_id
									"
									type="number"
									v-model.number="
										benefitValues[
											benefit.product_benefit_id
										].free_limit
									"
									placeholder="Limit Value"
									class="form-control form-control-sm"
									style="width: 120px"
									:max="benefit.max_free_limit"
									min="0"
								/>
							</div>
						</div>
						<!-- Save Changes Button -->
						<div
							class="col-md-12 d-flex justify-content-end align-items-end"
						>
							<button
								class="btn btn-primary px-4"
								@click="saveChanges"
							>
								Save Changes
							</button>
						</div>
					</div>
				</div>

				<!-- Risks Section -->
				<div class="mb-5">
					<h3 class="h5 fw-bold mb-4">Risks</h3>
					<div class="row g-4">
						<div class="col-md-6">
							<div class="card mb-3">
								<div
									class="card-body d-flex align-items-center"
								>
									<i class="fas fa-tag me-3 text-primary"></i>
									<span class="fw-semibold text-dark"
										>KBD338</span
									>
								</div>
							</div>
							<div class="card mb-3">
								<div
									class="card-body d-flex align-items-center"
								>
									<i class="fas fa-tag me-3 text-primary"></i>
									<span class="fw-semibold text-dark"
										>KYK992</span
									>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Next Button -->
				<div class="mt-4 d-flex justify-content-end">
					<button
						class="btn btn-success px-4 d-flex align-items-center"
						@click="
							$router.push({
								name: 'ClientQuotationSummary',
								params: {
									id: selectedClientRecommendation.guest_client_quotation_recommendation_ref,
								},
							})
						"
					>
						Next
						<span class="ms-2">→</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import clientQuotations from '../rsc/stores/client-quotations';
import { mapGetters, mapActions } from 'vuex';

export default {
	beforeCreate() {
		// Event.$emit("loader:show", true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('clientQuotations');
	},
	created() {
		utils.registerModule('clientQuotations', clientQuotations, this.$store);
	},
	computed: {
		...mapGetters([
			'quotationID',
			'loading',
			'clientQuotations',
			'showQuotationModal',
			'selectedClientQuote',
			'selectedClientRecommendation',
			'selectedClientQuoteSummary',
		]),
	},
	data() {
		return {
			articles: [],
			selectedBenefit: null, // Stores the product_benefit_id of the selected benefit
			benefitValues: {}, // Dynamically populated with product_benefit_id keys
		};
	},
	methods: {
		...mapActions([
			'viewClientQuote',
			'acceptClientQuote',
			'declineClientQuote',
			'viewClientQuoteRecommendation',
			'viewClientQuoteSummary',
			'updateGuestRecommendationBenefit',
		]),
		formatDate(dateString) {
			if (!dateString) return 'Invalid Date';
			try {
				const date = new Date(dateString);
				if (isNaN(date.getTime())) return 'Invalid Date';
				const monthNames = [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December',
				];
				const month = monthNames[date.getUTCMonth()];
				const day = String(date.getUTCDate()).padStart(2, '0');
				const year = date.getUTCFullYear();
				return `${month} ${day} ${year}`;
			} catch (error) {
				console.error('Date formatting error:', error);
				return 'Invalid Date';
			}
		},
		// Initialize benefitValues dynamically for each benefit
		initializeBenefitValues() {
			// Ensure product_benefit_details exists
			if (this.selectedClientRecommendation.product_benefit_details) {
				this.selectedClientRecommendation.product_benefit_details.forEach(
					(benefit) => {
						if (!this.benefitValues[benefit.product_benefit_id]) {
							this.$set(
								this.benefitValues,
								benefit.product_benefit_id,
								{
									free_limit: benefit.free_limit || 0,
								},
							);
						}
					},
				);
			}
		},
		// Save the changes for the selected benefit
		saveChanges() {
			if (this.selectedBenefit) {
				const selectedBenefitData =
					this.selectedClientRecommendation.product_benefit_details.find(
						(benefit) =>
							benefit.product_benefit_id === this.selectedBenefit,
					);
				if (!selectedBenefitData) {
					alert('Selected benefit not found.');
					return;
				}
				const freeLimit =
					parseFloat(
						this.benefitValues[this.selectedBenefit].free_limit,
					) || 0;
				if (freeLimit > selectedBenefitData.max_free_limit) {
					alert(
						`Free limit cannot exceed ${selectedBenefitData.max_free_limit}.`,
					);
					return;
				}
				const updatedBenefit = {
					product_benefit_id: this.selectedBenefit,
					guest_client_recommendation_id:
						this.selectedClientRecommendation
							.guest_client_recommendation_id,
					free_limit: freeLimit,
				};
				console.log('Updated Benefit:', updatedBenefit);
				// Call the Vuex action to update the benefit
				this.updateGuestRecommendationBenefit(updatedBenefit)
					.then(() => {
						// alert('Benefit saved successfully!');
					})
					.catch((error) => {
						// console.error('Error saving benefit:', error);
						//alert('Failed to save benefit. Please try again.');
					});
			} else {
				alert('Please select a benefit to save.');
			}
		},
	},
	async mounted() {
		Event.$emit('loader:show', false);

		await this.viewClientQuote();
		await this.viewClientQuoteRecommendation({
			guest_client_quotation_recommendation_ref:
				'guest-client-quo-reco/8d1yhhutzlmaqjai3k',
		});
		// Initialize benefit values after data is loaded
		this.initializeBenefitValues();
	},
};
</script>

<style lang="less" scoped>
.profile-img {
	width: 100px;
	height: 100px;
	object-fit: cover;
	border-radius: 50%;
}
.star-rating .fa-star {
	color: #ddd;
}
.star-rating .fa-star.checked {
	color: #ffc107;
}
.quotation-card {
	border-radius: 10px;
	padding: 20px;
}
</style>
